import React from "react";

function ComingSoon() {
  return (
    <div style={styles.container}>
      <h1 style={styles.title}>🚀 Coming Soon</h1>
      <p style={styles.subtitle}>
        We’re working hard to bring something amazing for you.
      </p>
    </div>
  );
}

const styles = {
  container: {
    height: "100vh",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "#f5f7fa",
    textAlign: "center",
  },
  title: {
    fontSize: "48px",
    marginBottom: "10px",
    color: "#333",
  },
  subtitle: {
    fontSize: "18px",
    color: "#666",
  },
};

export default ComingSoon;
